export function normalizeEndpointItem(item) {
  const { media } = item

  let image = null
  if (media) {
    image = {
      id: media.id,
      url: media.source_url,
      alt: media.alt_text,
      ...media.media_details,
    }
  }

  return {
    id: item.ID,
    type: item.post_type,
    title: item.post_title,
    link: item.link,
    image,
    badges: item.badges || [],
    featuredBadges: item.featuredBadges || [],
    lines: item.lines || null,
    chefPeople: null,
  }
}
